const MOBILE_WIDTH = 768;
const TABLET_WIDTH = 1024;

export const deviceUtil = {
    isMobileLayout: function () {
        return window.innerWidth <= MOBILE_WIDTH;
    },
    isDesktopLayout: function () {
        return  window.innerWidth >= TABLET_WIDTH;
    }
}
